import { Tab, Tabs } from '@mui/material'
import { useState } from 'react'

import MemberDataStructSetting from './fragement/MemberDataStructSetting'
const MemberSetting = () => {
    const [tabIndex,setTabIndex] = useState(0)    
    const handleTabChange = (idx) =>{
        setTabIndex(idx)
    }
    return <>
        <Tabs value={tabIndex} onChange={handleTabChange} >
            <Tab label="Member Information Struct" />            
        </Tabs>
        {tabIndex == 0 && <MemberDataStructSetting />}
    </>
}

export default MemberSetting